import { render, staticRenderFns } from "./PlanChangeStep2.vue?vue&type=template&id=58844662&scoped=true"
import script from "./PlanChangeStep2.vue?vue&type=script&lang=js"
export * from "./PlanChangeStep2.vue?vue&type=script&lang=js"
import style0 from "./PlanChangeStep2.vue?vue&type=style&index=0&id=58844662&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58844662",
  null
  
)

export default component.exports